import * as Sentry from "@sentry/astro";

import { universalStorage } from "@/utils/universal-storage";
import { isBrowser } from "@/utils/platform";

const SentryAddEventProcessorFn = isBrowser() ? Sentry.addGlobalEventProcessor : Sentry.addEventProcessor;

// Enrich Sentry events with more metadata
SentryAddEventProcessorFn(function (event, hint) {
  const user_id = universalStorage.get("user_id");
  if (user_id) event.user = { id: user_id };

  return event;
});
